var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-select',{attrs:{"label":_vm.label,"fancy":_vm.fancy,"value":_vm.selectedValue,"items":_vm.bankTypeItems,"disabled":_vm.disabled},on:{"input":function($event){return _vm.onInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }